/**
 * Asynchronously loads the component for Customer
 */

import React from "react";
import loadable from "../../../utils/loadable";

export default loadable(() => import("./Solution1"), {
  fallback: <div>Loading...</div>,
});
